import katex from 'katex';

/**
 * Preprocesses text containing LaTeX mathematical expressions.
 * Renders block and inline math directly to HTML using KaTeX to ensure
 * they display correctly even inside raw HTML wrappers (like <보기> boxes).
 */
export const preprocessLatex = (text: string): string => {
    if (!text) return '';
    
    let processed = text;
    
    // 1. Standardize inline delimiters: \\( ... \\) or \( ... \) -> $ ... $
    processed = processed.replace(/\\\\\(([\s\S]*?)\\\\\)/g, '$$1$');
    processed = processed.replace(/\\\(([\s\S]*?)\\\)/g, '$$1$');
    
    // 2. Standardize block delimiters: \\\[ ... \\\] or \[ ... \] -> $$ ... $$
    processed = processed.replace(/\\\\\[([\s\S]*?)\\\\\]/g, '$$\n$1\n$$');
    processed = processed.replace(/\\\[([\s\S]*?)\\\]/g, '$$\n$1\n$$');
    
    // 3. Fix double backslashes in JSON strings (e.g. \\frac -> \frac)
    processed = processed.replace(/\\\\([a-zA-Z]+)/g, '\\$1');
    
    // 4. Render block math $$ ... $$ to HTML string using KaTeX
    processed = processed.replace(/\$\$([\s\S]+?)\$\$/g, (_, math) => {
        try {
            return katex.renderToString(math.trim(), { displayMode: true, throwOnError: false });
        } catch (e) {
            return math;
        }
    });

    // 5. Render inline math $ ... $ to HTML string using KaTeX
    processed = processed.replace(/\$(?!\$)([^$\n]+?)\$/g, (_, math) => {
        try {
            const mathExpr = math.trim();
            const cleanMath = mathExpr.startsWith('\\displaystyle') ? mathExpr : `\\displaystyle ${mathExpr}`;
            return katex.renderToString(cleanMath, { displayMode: false, throwOnError: false });
        } catch (e) {
            return math;
        }
    });
    
        // 6. Automatically insert line breaks before numbered items like (1), (2), (3) to clean up layout
    processed = processed.replace(/([^\n])\s*(\([0-9]+\))/g, '$1  \n$2');
    
    return processed;
};
